import SEO from "@/components/SEO";
import { Link } from "react-router-dom";
import { Compass, Handshake, ShieldCheck, HeartHandshake, ArrowRight } from "lucide-react";

export default function Philosophie() {
  return (
    <>
      <SEO
        title="Notre philosophie — venteaterme.fr"
        description="Prix ferme, mensualités fixes, sans intérêts et sans indexation : la vision claire et engagée de venteaterme.fr."
      />
      <section className="pt-24 pb-10 bg-navy text-cream">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-accent-brand font-bold mb-4">Notre philosophie</div>
          <h1 className="font-serif text-4xl md:text-6xl leading-tight">Un contrat clair, ferme et loyal.</h1>
          <p className="text-cream/80 mt-6 max-w-3xl text-lg leading-relaxed">
            Nous croyons qu'un contrat de vente à terme doit être compris par tous, sans zone grise, sans mécanisme
            d'ajustement, sans surprise. Notre standard, sans compromis&nbsp;: <strong className="text-accent-brand">prix ferme,
            mensualités fixes, sans intérêts, sans indexation</strong>.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-10 space-y-10">
          {[
            { icon: Compass, title: "Le prix est ferme", text: "Le prix négocié le jour de la signature notariée est le prix final. Il n'est pas indexé sur l'ICC, l'IRL ou l'IPC. Il n'est jamais révisé. Vendeur et acheteur savent, dès le premier jour, quel sera le montant total échangé." },
            { icon: Handshake, title: "Les mensualités sont fixes", text: "Chaque mensualité correspond à une simple fraction du prix, calculée par division. Aucun intérêt, aucune capitalisation, aucun mécanisme d'indexation. Ce n'est pas un prêt bancaire déguisé." },
            { icon: ShieldCheck, title: "La sécurité juridique avant tout", text: "L'acte est signé chez notaire. Le vendeur est protégé par l'hypothèque légale spéciale (art. 2402 du Code civil) et par la clause résolutoire. L'acheteur bénéficie d'un contrat lisible, sans clauses cachées." },
            { icon: HeartHandshake, title: "Un accompagnement gratuit", text: "La plateforme est 100 % gratuite pour tous. Nous ne prélevons aucune commission, aucun honoraire. Les transactions se concluent directement entre les parties chez notaire — nous ne sommes ni agent ni mandataire." },
          ].map((p, i) => (
            <div key={i} className="grid md:grid-cols-[80px_1fr] gap-6 pb-8 border-b border-navy/10 last:border-0">
              <div><p.icon className="text-accent-brand" size={48} strokeWidth={1.4} /></div>
              <div>
                <h2 className="font-serif text-2xl md:text-3xl text-navy mb-2">{p.title}</h2>
                <p className="text-navy/75 leading-relaxed">{p.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-16 bg-navy text-cream">
        <div className="max-w-3xl mx-auto text-center px-6">
          <h2 className="font-serif text-3xl md:text-4xl mb-4">Prêt à concrétiser votre projet&nbsp;?</h2>
          <p className="text-cream/80 mb-8">Testez notre simulateur ou déposez une annonce — c'est gratuit et sans engagement.</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/simulateur" className="inline-flex items-center justify-center gap-2 bg-accent-brand text-white px-8 py-3 font-bold tracking-wide hover:bg-[#B08D22] transition-colors">
              Simuler mon opération <ArrowRight size={18} />
            </Link>
            <Link to="/deposer-annonce" className="inline-flex items-center justify-center gap-2 border-2 border-cream/40 text-cream px-8 py-3 font-bold tracking-wide hover:bg-cream hover:text-navy transition-colors">
              Déposer une annonce
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
